import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, DatePicker, Radio, Button, message, Spin, Row, Col,Typography, Tooltip, Empty } from 'antd';
import {CopyOutlined} from '@ant-design/icons'
import {marked} from 'marked';
import DOMPurify from 'dompurify';
import IconButtonGroup from '../IconButtonGroup'
import ReactMarkdown from 'react-markdown';

const FullScreenModal = ({open, setOpen, text, contentType}) => {
    const [modalContent, setModalContent] = useState(null)
    const handleOk = () => {
        setOpen(false);
    };

    const handleCancel = () => {
        setOpen(false);
    };

    const markdownToHtml = (markdown) => {
        const rawHtml = marked.parse(markdown); // Adjusted to use `parse` method
        return DOMPurify.sanitize(rawHtml);// Sanitize HTML to prevent XSS attacks
    };

    useEffect(() => {
        if (text) {
            setModalContent(text);
        }
    }, [text]);

    function splitMarkdownIntoSections(markdown) {
      if (/^#{1,6}\s/m.test(markdown)) {
        const lines = markdown.split('\n');
        const sections = [];
        let currentSection = [];
        lines.forEach((line) => {
          if (/^#{1,6}\s/.test(line) && currentSection.length > 0) {
            sections.push(currentSection.join('\n').trim());
            currentSection = [line];
          } else {
            currentSection.push(line);
          }
        });
        if (currentSection.length > 0) {
          sections.push(currentSection.join('\n').trim());
        }
        return sections;
      } else if (markdown.includes('\n---\n')) {
        return markdown
          .split('\n---\n')
          .map((section) => section.trim())
          .filter((section) => section.length > 0);
      } else {
        const lines = markdown.split('\n');
        const sections = [];
        let currentSection = [];
        lines.forEach((line) => {
          if (!line.trim().startsWith('-') && line.trim().endsWith(':')) {
            if (currentSection.length > 0) {
              sections.push(currentSection.join('\n').trim());
              currentSection = [];
            }
          }
          currentSection.push(line);
        });
        if (currentSection.length > 0) {
          sections.push(currentSection.join('\n').trim());
        }
        return sections;
      }
    }
    
    const markdownToPlainText = (markdown) => {
      return markdown
        .replace(/[#*_>`~]/g, '')
        .replace(/\[(.*?)\]\(.*?\)/g, '$1')
        .replace(/\*\*(.*?)\*\*/g, '$1')
        .replace(/__(.*?)__/g, '$1')
        .replace(/!\[(.*?)\]\(.*?\)/g, '$1')
        .replace(/<\/?[^>]+(>|$)/g, '')
        .replace(/\n\s*\n/g, '\n\n')
        .trim();
    };
    
    // A card component that renders one markdown section with a copy icon.
    const MarkdownSectionCard = ({ sectionContent }) => {
      const rawTitle = sectionContent.split('\n').find((line) => line.trim() !== '') || 'Section';
      const copiedSectionContent = markdownToPlainText(sectionContent);
      const handleCopy = async () => {
        try {
          await navigator.clipboard.writeText(copiedSectionContent);
          message.success('Section copied to clipboard!');
        } catch (error) {
          message.error('Failed to copy section.');
        }
      };
    
      return (
        <div style={{ padding: '10px' }}>
          <div style={{ textAlign: 'right', marginBottom: '-20px' }}>
            <Tooltip title="Copy Section">
              <CopyOutlined onClick={handleCopy} style={{ cursor: 'pointer', fontSize: '16px' }} />
            </Tooltip>
          </div>
          <ReactMarkdown>{sectionContent}</ReactMarkdown>
          <hr />
        </div>
      );
    };
    
    // Component that receives a markdown string, splits it, and renders each section.
    const MarkdownSectionRenderer = ({ markdown }) => {
      if (!markdown) return <Empty description="No Content Found" />;
      const sections = splitMarkdownIntoSections(markdown);
      return (
        <>
          {sections.map((section, index) => (
            <MarkdownSectionCard key={index} sectionContent={section} />
          ))}
        </>
      );
    };
    return (
        <Modal
          title={"Fullscreen View"
            // <Row>
            //   <Col lg={8} md={8} sm={24} xs={24}>                 
            //     <Typography.Title level={5} style={{ margin: 0 }}>Fullscreen View</Typography.Title>
            //   </Col>
            //   <Col lg={15} md={15} sm={24} xs={24} style={{ textAlign: "right" }}>
            //     <IconButtonGroup 
            //       text={assessment == null ? "" :assessment} 
            //       feature={{ edit: false, copy: false, download: true, email: true }} 
            //       fileId={fileId} 
            //       contentType={"assessment_report"}
            //     />
            //   </Col>
            // </Row>
          }
          open={open}
          onOk={handleOk}
          onCancel={handleCancel}
          maskClosable={false}
          centered
          destroyOnClose={false}
          width={1000}
          bodyStyle={{ overflowY: 'auto', maxHeight: 'calc(100vh - 200px)' }}
        >    
         {modalContent ? 
         <>
         <div style={{ textAlign: "right" }}>
              <IconButtonGroup
                text={modalContent}
                feature={{
                  edit: false,
                  copy: true,
                  download: false,
                  email: false,
                  fullscreen: false,
                }}
                contentType={'summary'}
              />
            </div>
         {contentType && contentType === 'summary'? 
         <MarkdownSectionRenderer markdown={modalContent} />
         :
         <div className="message-content" dangerouslySetInnerHTML={{ __html: markdownToHtml(modalContent) }} /> }
         </>
         : 
          <div
            style={{
                // height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: "20px"
            }}
            >
            <Spin size="large" />
          </div>}
        </Modal>
    )
}

export default FullScreenModal